import React, { useCallback, useRef } from "react";
import { Button, FormSelect, Tab, TabContent, Tabs } from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";

import {
  AlertOK,
  CreateTooltip,
  defaultHeaderIconStyle,
  FormatThaiCard,
  GetThaiFormatDateTime,
  XButton,
} from "../../core/Helper";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../features/UserActions";
import styled from "styled-components";
import {
  AiOutlinePaperClip,
  AiFillSave,
  AiOutlineDelete,
  AiFillPrinter,
  AiOutlineVerticalAlignBottom,
  AiFillCloseCircle,
} from "react-icons/ai";
import { FcPicture } from "react-icons/fc";
import { FormControlBlack } from "../components/PageParams";
import StudyHistories from "./StudyHistories";
// import RichTextEditor from "../../components/RichTextEditor";
import StudyItems from "./StudyItems";
import { BsPen } from "react-icons/bs";
import TemplateEditorSaveAs from "./TemplateEditorSaveAs";
import { HiPlus } from "react-icons/hi";
import ConfirmDialogB from "../components/ConfirmDialogB";
import PopupReportStateOption from "./PopupReportStateOption";
import PopupOpenRemoteFile from "./PopupOpenRemoteFile";
import PopupReportPdf from "./PopupReportPdf";
import DownloadProgressPop from "./DownloadProgressPop";
import RadiComment from "./Z01-RadiComment";

import RadioResultPastCheck from "./RadioResultPastCheck";
import { StudyService } from "../../model/study";
import { StudyTemplateService } from "../../model/study-template";
import { Oval } from "react-loading-icons";
import { TokenService } from "../../model/token";
import RcxDownload from "./RcxDownload";
import "./css/rad-report.css";
import { GetPatientAge, GetPatientSex } from "../../core/Helper2";
import { ontLogo } from "../components/A01_Navbar";

function RadioResult(props) {
  const { userDetail } = props;
  const [editor, setEditor] = props.editor;
  const [showCtx, setShowCtx] = props.showCtx;
  const [selectedRow, setSelectedRow] = props.selectedRow;

  const dispatch = useDispatch();
  const [dataX, setDataX] = useState(null);
  const [showImage, setShowImage] = props.showImage;
  const [updateFlag, setUpdateFlag] = props.updateFlag;

  const [templateEditor, setTemplateEditor] = useState({ show: false });
  const [templList, setTempList] = useState([]);

  const [confirm, setConfirm] = useState({ show: false, action: () => {} });

  const [templateId, setTemplateId] = useState(-1);
  const [repcheck, setRepCheck] = useState(1);
  const [priceData, setPriceData] = useState([]);
  const [fullScreen, setFullScreen] = useState(false);
  //const [printFrm, setPrintFrm] = useState({ show: false, action: () => {} });

  const [reportStateOption, setReportStateOption] = useState({ show: false });
  const [fileOpener, setFileOpener] = useState({ show: false });

  // pdf renderer
  const [winPdfState, setWinPdfState] = useState({ show: false });
  const [saveCompleteAction, setSaveCompleteAction] = useState(false);

  const uploadType = { FILE: 1, CAPTURED: 2 };
  const editRef = useRef(null); // Ref for Editor

  const [loading, setLoading] = props.loading;
  const [loading2, setLoading2] = useState(false);
  const [enablePreview, setEnaPreview] = useState(false);

  const [studySubItem, setSubItem] = useState(null);
  const [showOld, setShowOld] = useState({ show: false, action: () => {} });

  /** File Download States */

  const [dwProgress, setDwlProgress] = useState(0);
  const [dwShow, setDwShow] = useState(false);
  const [dwText, setDwText] = useState("");
  const [dlgState, setDlgState] = useState({ show: false, callback: () => {} });

  const [radiComment, setRadiComment] = useState({
    show: false,
    action: () => {},
  });

  /** First use effect */

  useEffect(() => {
    if (editor?.show === true) {
      //*enable double click to select text
      //*effected event at 'App.js'
      document.dispatchEvent(
        new CustomEvent("mouse_event_update", { detail: { action: true } }),
      );
      getInfo(() => setLoading(false));
    }

    return () => {
      //* disable selection text
      document.dispatchEvent(
        new CustomEvent("mouse_event_update", { detail: { action: false } }),
      );

      setSaveCompleteAction(false);
      setWinPdfState({ show: false });

      //******* set last-result-len == 0 to reset  timer ""*/
      setResuLen(-1);
    };
  }, [editor]);

  useEffect(() => {
    if (!editor?.show) return;

    if (dataX?.priceItems) {
      setPriceData(dataX?.priceItems);
      refreshTemplate();
      if (dataX?.studyResult?.length > 0) {
        editRef.current.value =
          dataX?.studyResult.length > 0 && dataX?.studyResult[0]?.result_text;

        let ret = (dataX?.studyResult[0]?.result_text ?? "").replace(
          /\s*/g,
          "",
        );
        //**** รับค่าความยาวของผล */
        setResuLen(ret?.length ?? 0);

        /** saveCompleateAction === showReport */

        if (saveCompleteAction === true && dataX?.studyResult?.length > 0) {
          setWinPdfState({
            show:
              saveCompleteAction &&
              dataX?.studyResult?.[0]?.result_type_id >= 2,
            action: () => {
              setUpdateFlag(true);
              setEditor((pv) => ({ ...pv, show: false }));
              setSaveCompleteAction(false);
            },
          });
        }
      } else {
        editRef.current.value = "";
        setResuLen(0);
      }
    }
    return () => {
      setSaveCompleteAction(false);
    };
  }, [dataX]);

  //----------------------------------------------------------------------
  // หลังจากปรับปรุงรายการ template แล้ว ให้แสดงรายการแรกขึ้นมา กรณีไม่ใช่การแก้ไขผล
  useEffect(() => {
    if (templList.length > 0) {
      setTemplateId(templList[0].templ_id);
    }
  }, [templList]);

  /*  แสดงข้อมูลคนไข้  */
  const getInfo = async (callback) => {
    if (selectedRow == null) return;
    let tmp = await StudyService.GetRadioInfoWithHistory({
      StudyInfo: { ...selectedRow },
      UserInfo: userDetail,
    });

    if (tmp != null) {
      setDataX({
        studyInfo: {
          ...tmp?.StudyInfo[0],
          patients_idcard:
            tmp &&
            tmp?.StudyInfo[0]?.patients_idcard &&
            FormatThaiCard(tmp?.StudyInfo[0]?.patients_idcard),
        },
        attachedFile: tmp?.StudyFileAttached,
        priceItems: tmp?.PriceItems,
        studyResult: tmp?.StudyResults,
        studyHistory: tmp?.StudyHistory,
      });

      setRepCheck(
        tmp.StudyResults && tmp.StudyResults.length > 0
          ? tmp.StudyResults[0].result_type_id
          : 1,
      );
    } else {
      dispatch(
        setReminder({ show: true, message: "ไม่พบข้อมูล", type: "error" }),
      );
    }
    callback();
  };

  /* REFRESH TEMPLATE  */
  const refreshTemplate = async () => {
    let goodList = "";
    if (dataX?.priceItems?.length > 0) {
      dataX?.priceItems?.map((r) => {
        goodList += r.goodid + ",";
      });

      if (goodList.length > 0) {
        goodList = goodList.substring(0, goodList.length - 1);
      }
    }

    // * เรียก และ แสดงรายการ Template ทั้งหมด
    if (editor.show === true) {
      let ret = await StudyTemplateService.GetTemplateList({
        UserInfo: userDetail,
        GoodInfo: goodList,
        StudyInfo: dataX.studyInfo,
      });

      if (ret != null) {
        setTempList(ret?.rows ?? []);
      } else {
        dispatch(
          setReminder({
            show: true,
            message: "ไม่พบรายการ Template",
            type: "error",
          }),
        );
      }
    }

    setDefaultTemplateEditor();
  };

  const setDefaultTemplateEditor = () => {
    setTemplateEditor({ show: false, action: () => {} });
  };

  //----------------------------------------------------------------------
  //
  const saveData = async (resultState, actionSave) => {
    const oResult = editRef.current.value;
    setLoading(true);

    let ret = await StudyService.UpdateStudyResult({
      UserInfo: userDetail,
      StudyInfo: selectedRow,
      ReportInfo: { reptype: resultState },
      ResultText: oResult,
    });
    if (ret != null) {
      setLoading(false);
      getInfo(actionSave);
    } else {
      setLoading(false);
      dispatch(
        setReminder({
          show: true,
          message: "ไม่สามารถบันทึกผลได้",
          type: "error",
        }),
      );
    }
  };

  /*** -------------------- Show Image ------------------------------ */
  const imageButtonClick = (item) => {
    setShowImage({
      show: true,
      imagePath: process.env.REACT_APP_API + "/" + item.image_path,
      imageName: item.image_name,
    });
  };

  //**  Open linked file from upload complete! */
  const openLink = (item) => {
    let url = process.env.REACT_APP_API + "/" + item.image_path;
    window.open(url, "_blank", "noreferrer");
  };

  const showTemplateEditor = (type) => {
    if (editRef.current.value.trim() === "") {
      dispatch(
        setReminder({
          show: true,
          message:
            "ไม่มีข้อความบน Tempate ต้นฉบับ \n กรุณากรอกข้อความบนเอกสารเพือนำไปใช้เป็นต้นแบบ",
          type: "error",
        }),
      );
      return;
    }

    if (type === "new") {
      setTemplateEditor({
        show: true,
        templ_id: -1,
        action: () => {
          refreshTemplate();
        },
      });
    } else {
      if (templateId === 0) {
        dispatch(
          setReminder({
            show: true,
            message: "ยังไม่ได้เลือก Template",
            type: "error",
          }),
        );
        return;
      }
      setTemplateEditor({
        show: true,
        templ_id: templateId,
        action: () => {
          refreshTemplate();
        },
      });
    }
  };

  // เมื่อมีการเลือก Template ใหม่
  const selectedTemplateChanged = (e) => {
    setTemplateId(e.target.value);
  };

  const showCurrentTempate = () => {
    getReportTemplateDetail();
  };

  // เรียก และ แสงรายละเอียด Template จากรายการที่เลือก
  const getReportTemplateDetail = async () => {
    if (!templateId) return;

    let ret = await StudyService.GetReportTemplateDetail({
      UserInfo: userDetail,
      ItemInfo: { templ_id: templateId },
    });

    if (ret != null) {
      editRef.current.value += "\n" + ret?.TemplateDetail?.[0]?.templ_text;
    } else {
      dispatch(
        setReminder({
          show: true,
          message: "ไม่พบข้อมูล",
          type: "error",
        }),
      );
    }
  };

  const RemoveTemplate = async () => {
    if (templateId === 0) {
      dispatch(
        setReminder({
          show: true,
          message: "กรุณาเลือก Template ที่ต้องการลบ",
          type: "error",
        }),
      );
      return;
    }

    let ret = await StudyTemplateService.RemoveTemplate({
      UserInfo: userDetail,
      TemplateInfo: { templ_id: templateId },
    });
    if (ret != null) {
      dispatch(
        setReminder({ show: true, message: "ยกเลิกสมบูรณ์", type: "success" }),
      );
      refreshTemplate();
    } else {
      dispatch(
        setReminder({
          show: true,
          message: "ไม่พบรายการ",
          type: "error",
        }),
      );
    }
  };

  const handleClose = () => {
    if (dwProgress !== 0) {
      dispatch(
        setReminder({
          show: true,
          message: "กรุณารอสักครู่ เพื่อ Download เสร็จ",
          type: "error",
        }),
      );
      return;
    }
    setEditor((pv) => ({ ...pv, show: false }));
  };

  const setCommentShow = () => {
    setRadiComment({
      show: true,
      action: (data) => {},
    });
  };

  // Auto Saving Data  *************************
  // -------------------------------------------

  const [restLen, setResuLen] = useState(-1);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (restLen > -1) {
      const timeoutId = setInterval(() => {
        let lastRet = editRef.current?.value?.replace(/\s*/g, "").length ?? 1;

        if (lastRet !== restLen) {
          //console.log(new Date().toLocaleString(), "Autosave start ....");
          autoSave();
          setResuLen(lastRet);
        }
      }, 60 * 1000);

      return () => {
        // when restlen = 0
        clearInterval(timeoutId);
        //console.log("Timer for chack character size ended..");
      };
    }
  }, [restLen]);

  //**** Auto Saving Report */
  const autoSave = async () => {
    // console.log("autosave... start");
    const oResult = editRef.current?.value;
    const resultId = dataX?.studyResult[0]?.std_result_id ?? -1;
    setSaving(true);
    let ret = await StudyService.UpdateStudyResultAutoDraft({
      UserInfo: userDetail,
      StudyInfo: selectedRow,
      ReportInfo: { resultId: resultId },
      ResultText: oResult,
    });
    if (ret) {
      //console.log("auto-saved");
    }
    setSaving(false);
  };
  const resultKeyDown = (e) => {
    // let a = e.target.value.replace(/\s*/g, "");
    // console.log(restLen, a.length);
  };

  const theme = useSelector((s) => s.theme.theme);

  const openUrl = async (e) => {
    e.preventDefault();

    // ** get token
    setLoading2(true);
    let info = await TokenService.GetToken(null, userDetail);
    var a = document.createElement("a");
    a.href = "rcx-dicom://?token=" + (info?.token ?? "");
    document.body.appendChild(a);
    a.click();

    // const launcher = new RCXDicomLauncher(userDetail);
    // launcher.launchDicomOpener();
    setTimeout(() => {
      // ถ้าหน้าต่างยังคงเป็น focus อยู่ แสดงว่าโปรแกรมอาจไม่เปิด
      if (document.hasFocus()) {
        console.log("still focus .....");
        // this.showInstallPrompt();
        setDlgState((pv) => ({ ...pv, show: true }));
      }
      setLoading2(false);
    }, 3000);
  };

  const confirmSave = () => {
    setRepCheck(3);
    // แสดงตัวเลือกประเภทการผล {}
    setReportStateOption({
      show: true,
      action: (e) => {
        if (e && e.confirm) {
          saveData(e.resultType, () => {
            /** ตั้งค่าสถานะการบันทึกสมบูรณ์  xxx */
            // setSaveCompleteAction(true);

            // if (e.resultType > 1) {
            //   // previewPdf();
            // } else {
            // AlertOK("บันทึกสมบูรณ์", dispatch);
            setUpdateFlag(true);
            setEditor((pv) => ({ ...pv, show: false }));
            // }
          });
        }
      },
    });
  };

  const showItems = useCallback(
    (val) => {
      if (!editor?.show) return;
      // console.log("callback", dataX);
      return getItem({ dataX });
    },
    [dataX, editor],
  );

  /*** -------------------------------------------------- */
  return (
    <MyModal
      // style={{ background: theme?.themeName === "light" ? "white" : "#252627" }}
      show={editor.show}
      backdrop={false}
      fullscreen
      style={{ padding: "0px", flex: "1" }}
    >
      <ModalHeaderBlack
        closeButton
        style={{ maxHeight: "50px" }}
        onHide={() => handleClose()}
      >
        {ontLogo}
        <div
          style={{
            // flex: "1",
            textAlign: "center",
            // color: "black",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          อ่านผล
        </div>
        {/* {props.formName} */}
      </ModalHeaderBlack>

      <ModalBodyBlack
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {/* {loading ? <Loading /> : <></>} */}
        <MainContainer>
          <Tabs>
            {/* -------------ประวัติการตรวจ------------ ITEM 2  */}
            <TabDiv eventKey="items" title="รายการ">
              <TabContentX>
                <DefaultHBox>
                  {showItems()}
                  <StudyItems {...{ priceData: [priceData, setPriceData] }} />
                </DefaultHBox>
              </TabContentX>
            </TabDiv>

            <TabDiv eventKey="history" title="Files">
              <TabContentX>
                <DefaultHBox>
                  <SelectionHeader>ประวัติเดิมในระบบ</SelectionHeader>
                  <HistoryTableWrapper>
                    <StudyHistories
                      {...{
                        data: [dataX, setDataX],
                        editor: [editor, setEditor],
                        userDetail: userDetail,
                        winState: [fileOpener, setFileOpener, setLoading],
                        selectedItem: [studySubItem, setSubItem],
                        showOldParam: [showOld, setShowOld],
                        dwState: [
                          dwProgress,
                          setDwlProgress,
                          dwShow,
                          setDwShow,
                          dwText,
                          setDwText,
                        ],
                      }}
                    />
                  </HistoryTableWrapper>

                  <SelectionHeader>ไฟล์แนบ</SelectionHeader>
                  <FileAttachmentArea>
                    {/* <span>ไฟล์แนบ</span> */}
                    <FileListBox>
                      {dataX &&
                        dataX?.attachedFile?.map((item, i) => {
                          switch (item.upload_type) {
                            case uploadType.FILE: //1
                              return (
                                <ImageLinkButton
                                  key={i}
                                  onClick={() => openLink(item)}
                                >
                                  <AiOutlinePaperClip
                                    style={styles.fileAttachIcon}
                                  />
                                  {`${item.image_name}`}
                                </ImageLinkButton>
                              );
                            case uploadType.CAPTURED: //2
                              return (
                                <ImageLinkButton
                                  key={i}
                                  onClick={() => openLink(item)}
                                >
                                  <FcPicture style={styles.fileAttachIcon} />
                                  {`${item.image_name}`}
                                </ImageLinkButton>
                              );
                            default:
                              return (
                                <ImageLinkButton
                                  key={i}
                                  onClick={() => openLink(item)}
                                />
                              );
                          }
                        })}
                    </FileListBox>
                  </FileAttachmentArea>

                  <SelectionHeader>หมายเหตุ</SelectionHeader>
                  <NoteTextArea
                    readOnly
                    as="textarea"
                    // rows={5}
                    value={dataX?.studyInfo?.study_remark}
                  ></NoteTextArea>
                </DefaultHBox>
              </TabContentX>
            </TabDiv>

            <TabDiv eventKey="result" title="ผลอ่าน">
              <TabContentX>
                <DefaultHBox>
                  {/* <!-- Report Header --> */}
                  <div class="report-header">
                    <div class="hospital-logo-section">
                      <div class="hospital-logo">
                        <div class="logo-emblem">
                          <img
                            style={{ height: "100px", width: "100px" }}
                            src={
                              "/logos/logo_branch_" +
                              dataX?.studyInfo.brchid +
                              ".png"
                            }
                            // src={
                            //   "/logos/logo_comp_" +
                            //   dataX?.studyInfo?.brchid +
                            //   ".png"
                            // }
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="hospital-info-text">
                      <div class="hospital-name-thai">{`${dataX?.studyInfo?.cust_prefix}${dataX?.studyInfo?.cust_name}`}</div>
                      <div class="hospital-detail">
                        {dataX?.studyInfo?.cust_addr1}
                      </div>
                      <div class="hospital-detail">
                        {dataX?.studyInfo?.cust_addr2}
                      </div>
                      <div class="hospital-detail">
                        {dataX?.studyInfo?.cust_phone}
                      </div>
                    </div>
                  </div>
                  {/*--  Patient Infomation --*/}
                  <div class="patient-info">
                    <div class="patient-info-row">
                      <span class="patient-info-label">ชื่อ-นามสกุล:</span>
                      <span class="patient-info-value">
                        {dataX?.studyInfo?.patients_name ?? ""}
                      </span>
                      <span class="patient-info-label" style={styleLeft30}>
                        อายุ:
                      </span>
                      <span class="patient-info-value">
                        {GetPatientAge(dataX?.studyInfo?.patients_age)}
                      </span>
                      <span class="patient-info-label" style={styleLeft30}>
                        เพศ:
                      </span>
                      <span class="patient-info-value">
                        {GetPatientSex(dataX?.studyInfo?.patients_sex)}
                      </span>
                    </div>
                    <div class="patient-info-row" style={{ marginTop: "8px" }}>
                      <span class="patient-info-label">HN:</span>
                      <span class="patient-info-value">
                        {dataX?.studyInfo?.patientid}
                      </span>
                      <span class="patient-info-label" style={styleLeft30}>
                        แผนกที่ส่ง:
                      </span>
                      <span class="patient-info-value">
                        {dataX?.studyInfo?.ward_short ?? ""}
                      </span>
                      <span class="patient-info-label" style={styleLeft30}>
                        แพทย์ผู้ส่ง:
                      </span>
                      <span class="patient-info-value">
                        {dataX?.studyInfo?.physician_staff_name}
                      </span>
                    </div>
                    <div class="patient-info-row" style={{ marginTop: "8px" }}>
                      <span class="patient-info-label">วันที่ตรวจ:</span>
                      <span class="patient-info-value">
                        01/11/2025 13:00:24
                      </span>
                      <span class="patient-info-label" style={styleLeft30}>
                        กำหนดรับผล:
                      </span>
                      <span class="patient-info-value">
                        01/11/2025 14:00:00
                      </span>
                      <span class="patient-info-label" style={styleLeft30}>
                        Priority:
                      </span>
                      <span class="patient-info-value">
                        {dataX?.studyInfo?.urgenttype_name}
                      </span>
                    </div>
                  </div>

                  <div class="toolbar">
                    <div class="template-label">Template:</div>
                    <FormSelect
                      className="template-dropdown"
                      aria-label="ตัวเลือก"
                      rows={templList}
                      onChange={selectedTemplateChanged}
                      name={"goodCateId"}
                    />
                    <div class="template-actions">
                      {CreateTooltip(
                        "Use this template.",
                        <XButton
                          style={Styles.buttonTemplate}
                          onClick={() => showCurrentTempate()}
                        >
                          {" "}
                          <AiOutlineVerticalAlignBottom />
                        </XButton>,
                        "",
                      )}
                      {CreateTooltip(
                        "Save as new template",
                        <XButton
                          style={Styles.buttonTemplate}
                          onClick={() => showTemplateEditor("new")}
                        >
                          {" "}
                          <HiPlus />
                        </XButton>,
                        "",
                      )}
                      {CreateTooltip(
                        "Edit selected template",
                        <XButton
                          style={Styles.buttonTemplate}
                          onClick={() => showTemplateEditor("edit")}
                        >
                          {" "}
                          <BsPen />
                        </XButton>,
                        "",
                      )}
                      {CreateTooltip(
                        "Delete this template",
                        <XButton
                          style={Styles.buttonTemplate}
                          onClick={() =>
                            setConfirm({
                              show: true,
                              title: "กรุณายืนยันการลบ Template ", //GetConfirmTitle("DELETE"),
                              action: (e) => {
                                if (e === true) {
                                  RemoveTemplate();
                                }
                              },
                            })
                          }
                        >
                          <AiOutlineDelete />
                        </XButton>,
                        "",
                      )}
                    </div>
                  </div>

                  {/* <HBox
                  style={{
                    display: props.enableSave ? "flex" : "none",
                    margin: "0px",
                    padding: "5px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <AiOutlineAudit
                    style={{ color: "var(--fore-primary)", fontSize: "20px" }}
                  />
                  <span style={defaultSpanText}>Template:</span>
                  <FormSelectBlack
                    style={{
                      color: "var(--select-item-color)",
                      flex: "1",
                      marginRight: "5px",
                    }}
                    aria-label="ตัวเลือก"
                    rows={templList}
                    onChange={selectedTemplateChanged}
                    name={"goodCateId"}
                  />
                  
                </HBox> */}

                  {saving ? (
                    <DivAutoSave>
                      <Oval height={20} stroke="var(--icon-fore)" />
                      <span>Auto Saving ...</span>
                    </DivAutoSave>
                  ) : (
                    <></>
                  )}

                  {/* Result Editor */}
                  <EditorTextArea
                    as="textarea"
                    rows={24}
                    ref={editRef}
                    onKeyDown={resultKeyDown}
                  ></EditorTextArea>

                  <div className="submit-section">
                    <button
                      className="submit-btn"
                      onClick={() => {
                        confirmSave();
                      }}
                    >
                      <AiFillSave style={defaultHeaderIconStyle} />
                      Submit
                    </button>

                    {/* Preview Button */}
                    {enablePreview ? (
                      <Button
                        variant="info"
                        onClick={() => {
                          //previewPdf();
                        }}
                      >
                        {" "}
                        <AiFillPrinter style={Styles.buttonImage} />
                        Preview
                      </Button>
                    ) : (
                      <></>
                    )}

                    {/* Close Button */}
                    <button
                      className="close-btn"
                      onClick={() => {
                        setEditor((pv) => ({ ...pv, show: false }));
                      }}
                    >
                      <AiFillCloseCircle style={defaultHeaderIconStyle} />
                      Close
                    </button>
                  </div>
                </DefaultHBox>
              </TabContentX>
            </TabDiv>
          </Tabs>
        </MainContainer>
      </ModalBodyBlack>

      <ModalFooterBlack style={{ justifyContent: "center" }}></ModalFooterBlack>

      <TemplateEditorSaveAs
        {...{
          winState: [
            templateEditor,
            setTemplateEditor,
            editRef,
            priceData,
            setPriceData,
          ],
        }}
      />

      <ConfirmDialogB {...{ winState: [confirm, setConfirm] }} />

      <PopupReportStateOption
        {...{
          winState: [
            reportStateOption,
            setReportStateOption,
            repcheck,
            setRepCheck,
            props.enableSave,
            dataX,
          ],
        }}
      />
      <PopupOpenRemoteFile
        {...{ userDetail, winState: [fileOpener, setFileOpener, dataX] }}
      />
      <PopupReportPdf
        {...{
          winState: [winPdfState, setWinPdfState],
          data: dataX,
          userInfo: userDetail,
          loading: [loading, setLoading],
        }}
      />
      {/* <StudyHistories
        {...{
          data: [dataX, setDataX],
          editor: [editor, setEditor],
          userDetail: userDetail,
          winState: [fileOpener, setFileOpener, setLoading],
          selectedItem: [studySubItem, setSubItem],
          showOldParam: [showOld, setShowOld],
          dwState: [
            dwProgress,
            setDwlProgress,
            dwShow,
            setDwShow,
            dwText,
            setDwText,
          ],
        }}
      /> */}

      <DownloadProgressPop
        {...{
          options: [
            dwProgress,
            setDwlProgress,
            dwShow,
            setDwShow,
            dwText,
            setDwText,
          ],
        }}
      />

      {/* <PrintDocu {... {winState:[printFrm, setPrintFrm], ...editRef}} /> */}
      <RadiComment
        {...{ radiComment: [radiComment, setRadiComment], dataX: [dataX] }}
      />

      <RadioResultPastCheck
        {...{
          userDetail: userDetail,
          selectedItem: [studySubItem, setSubItem],
          showParam: [showOld, setShowOld],
        }}
      />

      <RcxDownload {...{ dlgState: [dlgState, setDlgState] }} />
    </MyModal>
  );
}

const styleLeft30 = {
  marginLeft: "30px",
};

const FileListBox = styled.p`
  padding: 10px 1px 10px 5px;
  color: white;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  justify-content: "space-between";
`;

const ImageLinkButton = styled.div`
  text-decoration: none;
  color: #7a047a;
  cursor: pointer;
  padding: 5px 15px;
  margin: 1px 5px 1px 5px;
  transition: 100ms;
  font-size: 13px;
  word-break: break-word; // break-all;
  border-radius: 10px;
  :hover {
    transition: 0.5s;
    text-decoration: none;
    color: var(--fore-primary);
    background-color: #b0fac6;
  }
`;

const Styles = {
  accordionBody: { background: "var(--bg-primary)", padding: "0 0 0 0px" },
  buttonTemplate: { marginRight: "5px" },
  buttonImage: {
    marginTop: "5px",
    marginBottom: "5px",
    color: "var(--icon-fore)",
    height: "30px",
    width: "40px",
  },
  buttonImageBig: {
    marginRight: "5px",
    color: "var(--bg-primary)",
    height: "40px",
    width: "40px",
  },
  iconButton: { marginInlineEnd: "5px" },
  innerIconButton: { marginTop: "-5px" },
};

const styles = {
  fileAttachIcon: {
    color: "var(--fore-primary)",
    marginInline: "5px",
  },
};

const DivAutoSave = styled.div`
  position: absolute;
  right: 0px;
  height: 150;
  width: 300;
  color: var(--fore-primary);
  padding-inline: 20px;
  padding-block: 5px;
  opacity: 0.5;
`;

export default React.memo(RadioResult);

const TabDiv = styled(Tab)``;

const MainContainer = styled.div`
  flex: 1;
  display: block;
  justify-content: center;
  flex-direction: column;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
`;

//** กรอบภายในแท็ป */
const DefaultHBox = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-panel);
  background-color: white;
  padding: 50px;
  border-radius: 8px;
  margin-bottom: 20px;
  margin-inline: 20px;
  max-width: 1200px;
  //**ใช้กับ display:block */
  margin-left: auto;
  margin-right: auto;
`;

const SelectionHeader = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 15px;
  padding-bottom: 8px;
  border-bottom: 2px solid #48bb78;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const HistoryTableWrapper = styled.div`
  background: white;
  border-radius: 8px;
  /* overflow: hidden; */
  border: 1px solid #e2e8f0;
  /* height: 300px; */
  overflow-y: hidden, scroll;
  padding-block: 10px;
`;

const FileAttachmentArea = styled.div`
  background: #f7fafc;
  border: 2px dashed #cbd5e0;
  border-radius: 8px;
  padding: 20px;
  height: 200px;
  overflow-y: hidden, scroll;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  align-content: start;
`;

const NoteTextArea = styled(FormControlBlack)`
  width: 100%;
  min-height: 80px;
  padding: 12px;
  border: 1px solid #cbd5e0;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  color: #2d3748;
  resize: vertical;
`;

const EditorTextArea = styled(FormControlBlack)`
  font-family: "Times New Roman";
  width: 100%;
  min-height: 80px;
  padding: 12px;
  border: 1px solid #cbd5e0;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  color: #2d3748;
  resize: vertical;
`;

const getItem = (props) => {
  const { dataX } = props;
  const { studyInfo } = dataX ?? {};
  // console.log(studyInfo);
  return (
    <div>
      <div class="study-info-grid">
        <div class="study-info-item">
          <div class="study-label">วันเวลาที่ส่ง</div>
          <div class="study-value">
            {GetThaiFormatDateTime(studyInfo?.created)}{" "}
          </div>
        </div>
        <div class="study-info-item">
          <div class="study-label">วันเวลารับผล</div>
          <div class="study-value">
            {GetThaiFormatDateTime(studyInfo?.result_expected)}
          </div>
        </div>
        <div class="study-info-item">
          <div class="study-label">Priority</div>
          <div class="study-value">{dataX?.studyInfo?.urgenttype_name}</div>
        </div>
      </div>

      <div class="study-info-grid" style={{ marginTop: "20px" }}>
        <div class="study-info-item">
          <div class="study-label">โรงพยาบาล</div>
          <div class="study-value">{studyInfo?.cust_short}</div>
        </div>
        <div class="study-info-item">
          <div class="study-label">แผนก</div>
          <div class="study-value">{dataX?.studyInfo?.ward_short ?? ""}</div>
        </div>
        <div class="study-info-item"></div>
      </div>

      <div class="study-info-grid" style={{ marginTop: "20px" }}>
        <div class="study-info-item">
          <div class="study-label">แพทย์ผู้ส่ง</div>
          <div class="study-value">{studyInfo?.referring_physicians_name}</div>
        </div>
        <div class="study-info-item">
          <div class="study-label">เบอร์โทรแพทย์ผู้ส่ง/แผนก</div>
          <div class="study-value"></div>
        </div>
        <div class="study-info-item">
          <div class="study-label">รังสีแพทย์</div>
          <div class="study-value">{studyInfo?.radi_staff_name}</div>
        </div>
      </div>

      <div class="study-info-grid" style={{ marginTop: "20px" }}>
        <div class="study-info-item">
          <div class="study-label">HN</div>
          <div class="study-value">{dataX?.studyInfo?.patientid}</div>
        </div>
        <div class="study-info-item">
          <div class="study-label">เพศ</div>
          <div class="study-value">
            {GetPatientSex(studyInfo?.patients_sex)}
          </div>
        </div>
        <div class="study-info-item">
          <div class="study-label">เลขประจำตัวประชาชน / หนังสือเดินทาง</div>
          <div class="study-value">{studyInfo?.patients_idcard}</div>
        </div>
      </div>

      <div class="study-info-grid" style={{ marginTop: "20px" }}>
        <div class="study-info-item">
          <div class="study-label">คนไข้</div>
          <div class="study-value">{studyInfo?.patients_name}</div>
        </div>
        <div class="study-info-item">
          <div class="study-label">วันเกิดคนไข้</div>
          <div class="study-value"></div>
        </div>
        <div class="study-info-item">
          <div class="study-label">อายุผู้ป่วย</div>
          <div class="study-value">
            {GetPatientAge(studyInfo?.patients_age)}
          </div>
        </div>
      </div>

      {/* <!-- Service Table --> */}
      <div class="service-section">
        <div class="section-title" style={{ marginBottom: "10px" }}>
          บริการ
        </div>
      </div>
    </div>
  );
};

const TabContentX = styled(TabContent)`
  /* background: #dee7e2; */
  background: #f5f5f5;
  /* background: #93c3e4; */
  padding-block: 20px;
`;
